import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  LTTheme,
  LTThemeProvider,
  useColorMode
} from '@lambdatestincprivate/lt-components';
import '@lambdatestincprivate/lt-components/lib/index.css';
import App from './App';
import './index.css';

const ThemedApp = () => {
  const { resolvedMode } = useColorMode();
  return (
    <LTThemeProvider
      colorMode={resolvedMode}
      nightScheme="dark"
      theme={LTTheme}
    >
      <App />
    </LTThemeProvider>
  );
};

const container = document.getElementById('root');
if (container) {
  createRoot(container).render(
    <React.StrictMode>
      <ThemedApp />
    </React.StrictMode>
  );
}
